/*
 * This file is part of the Det Norske Teatret application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import './Soundcloud.scss';

/**
 * This is the Soundcloud component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 *
 * @return {JSX}
 */
function Soundcloud(props) {
  return (
    <div className="block podcast soundcloud" appear="true">
      <div>
        <iframe {...props} />
      </div>
    </div>
  );
}

export default Soundcloud;
